import api from "./axiosConfig";
import { WEB_COMPANY_PLATFORM_ENDPOINT } from "./apiEndpoints";
import { logError } from './errorLogService';

export const fetchCompanyPlatform = async () => {
  try {
    const response = await api.get(WEB_COMPANY_PLATFORM_ENDPOINT());
    return response.data;
  } catch (error) {
    console.error("Error fetching hero data, fetching default hero", error);

    await logError('company_platform_fetch', error, {
      endpoint: WEB_COMPANY_PLATFORM_ENDPOINT(),
      response_status: error.response?.status,
      response_data: error.response?.data,
    });

    return defaultHeroData;
  }
};

